import { ValidationError } from '_core/api/client';
import { BaseForm } from '_core/forms/baseForm';
import { FormErrors } from '_core/forms/formErrors';
import { InputPassword } from '_core/inputs/inputPassword';
import { useIsUnmounted } from '_core/useIsUnmounted';
import { Button, FormGroup, H2, InputGroup, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from './authContext';
import { FormPageWrapper } from './formPageWrapper';

export function LoginPage() {
  const auth = useAuth();
  const isUnmounted = useIsUnmounted();
  const [email, setEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState<string>();
  const [password, setPassword] = React.useState('');
  const [passwordError, setPasswordError] = React.useState<string>();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [formError, setFormError] = React.useState<string>();

  return (
    <FormPageWrapper>
      <H2>Вход</H2>

      <BaseForm
        onSubmit={async event => {
          try {
            setFormError(undefined);
            setEmailError(undefined);
            setPasswordError(undefined);
            setIsSubmitting(true);
            event.preventDefault();
            await auth.login(email, password);
          } catch (err) {
            if (err instanceof ValidationError) {
              if (err.formError.length !== 0) {
                setFormError(err.formError.join('\n'));
              }

              const fieldErrors = err.joinFieldErrors();

              if (fieldErrors.email) {
                setEmailError(fieldErrors.email as string);
              }

              if (fieldErrors.password) {
                setEmailError(fieldErrors.password as string);
              }
            } else {
              setFormError('Не удалось получить доступ: Непредвиденная ошибка');
              throw err;
            }
          } finally {
            if (!isUnmounted()) {
              setIsSubmitting(false);
            }
          }
        }}
      >
        <FormErrors error={formError} />

        <FormGroup
          helperText={emailError}
          intent={emailError ? Intent.DANGER : undefined}
          label="Email"
          labelFor="email"
          labelInfo="*"
        >
          <InputGroup
            autoComplete="username"
            disabled={isSubmitting}
            id="email"
            intent={emailError ? Intent.DANGER : undefined}
            large
            placeholder="user@example.com"
            type="email"
            value={email}
            onChange={event => setEmail(event.currentTarget.value)}
          />
        </FormGroup>

        <FormGroup
          helperText={passwordError}
          intent={passwordError ? Intent.DANGER : undefined}
          label="Пароль"
          labelFor="password"
          labelInfo="*"
        >
          <InputPassword
            autoComplete="current-password"
            disabled={isSubmitting}
            id="password"
            intent={passwordError ? Intent.DANGER : undefined}
            large
            placeholder="**********"
            value={password}
            onChange={event => setPassword(event.currentTarget.value)}
          />
        </FormGroup>

        <p style={{ textAlign: 'right' }}>
          <Link to="/reset-password">Получить доступ</Link>
        </p>

        <Button
          disabled={isSubmitting}
          fill
          intent={Intent.PRIMARY}
          large
          loading={isSubmitting}
          type="submit"
        >
          Войти
        </Button>
      </BaseForm>
    </FormPageWrapper>
  );
}
